module.exports = __webpack_public_path__ + "img/chelsea-fc.d854acff.png";